<template>
    <div class="sizer" @mousedown="mouseDown" style="position: absolute;bottom:-15px;right:-15px;background-color: whitesmoke;padding:4px;border-radius: 50%;">
        <svg width="20" height="20" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
             <line stroke-linecap="round" stroke-linejoin="undefined" id="svg_3" y2="6.31257" x2="20" y1="6.18757" x1="20" stroke-width="1.5" stroke="#000" fill="none"/>
             <line stroke-linecap="round" stroke-linejoin="undefined" id="svg_4" y2="6.31257" x2="20" y1="6.18757" x1="20" stroke-width="1.5" stroke="#000" fill="none"/>
             <line transform="rotate(45 28 28.2499)" stroke-linecap="rpund" stroke-linejoin="undefined" id="svg_8" y2="28.24989" x2="36.99991" y1="28.24989" x1="19" stroke-width="1.5" stroke="#000" fill="none"/>
             <line transform="rotate(45 11.25 10.75)" stroke-linecap="round" stroke-linejoin="undefined" id="svg_9" y2="10.74998" x2="20.24999" y1="10.74998" x1="2.25009" stroke-width="1.5" stroke="#000" fill="none"/>
             <line transform="rotate(90 34.0624 28.7499)" stroke="#000" stroke-linecap="round" stroke-linejoin="undefined" id="svg_12" y2="28.74988" x2="39.6249" y1="28.74988" x1="28.49995" stroke-width="1.5" fill="none"/>
             <line transform="rotate(90 5.06257 10.25)" stroke="#000" stroke-linecap="round" stroke-linejoin="undefined" id="svg_13" y2="10.24998" x2="10.62505" y1="10.24998" x1="-0.4999" stroke-width="1.5" fill="none"/>
             <line stroke="#000" stroke-linecap="round" stroke-linejoin="undefined" id="svg_14" y2="34.24985" x2="34.49992" y1="34.24985" x1="23.37498" stroke-width="1.5" fill="none"/>
             <line stroke="#000" stroke-linecap="round" stroke-linejoin="undefined" id="svg_15" y2="4.75001" x2="16.50002" y1="4.75001" x1="5.37507" stroke-width="1.5" fill="none"/>
           </svg>
    </div>
</template>

<script>

export default {
    beforeDestroy () {
        console.log('mSizer destroy')
        this.mouseUp();
    },
    data () {
        return {
            width: 0,
            height: 0,
            startX: 0,
            startY: 0,
            parent: false
        }
    },
    mounted () {
        this.parent = this.$el.parentElement;
    },
    methods: {
        mouseUp ( e ) {
            document.body.removeEventListener('mouseup',this.mouseUp);
            document.body.removeEventListener('mousemove',this.mouseMove);
        },
        mouseMove ( e ) {
            e.preventDefault();
            e.stopPropagation();
            var height = Math.max(this.height + ( e.clientY - this.startY ),114);
            var width = Math.max(this.width + ( e.clientX - this.startX ),300);
            this.parent.style.width = width+'px'
            this.parent.style.height = height+'px';
        },
        mouseDown ( e ) {
            this.startX = e.clientX;
            this.startY = e.clientY;
            var current = getComputedStyle(this.parent);
            this.width = parseInt(current.width);
            this.height = parseInt(current.height);
            document.body.addEventListener('mouseup',this.mouseUp);
            document.body.addEventListener('mousemove',this.mouseMove);
        }
    }
}

</script>